const locale = {
	PAGE_VERSION_UPDATE_TITLE: 'Nuovo aggiornamento',
	PAGE_VERSION_UPDATE_DESCRIPTION:
		'È richiesto il refresh della cache su dispositivi desktop tramite {windowsRefresh} (o {macOsRefresh} su macOS) oppure su dispositivi mobile seguendo la guida di {windowsLink} (o di {appleLink}).',
	PAGE_VERSION_UPDATE_VERSION_CURRENT: 'Versione client: {date}',
	PAGE_VERSION_UPDATE_VERSION_LATEST: 'Versione corrente: {date}'
};

export default locale;
